/**
 * 跳转合同页面
 */
import React, { useEffect } from 'react';

export default function () {

  useEffect(() => {
    switch (process.env.REACT_APP_ENV) {
      case 'dev':
        window.open('https://yun-dev.ywwl.com/supplyManage/DM27005074D931194412238924920431/_contractManage_list', '_blank');
        break;
      case 'test':
        window.open('https://yun-test.ywwl.com/supplyManage/DM27005074D931194412238924920431/_contractManage_list', '_blank');
        break;
      default:
        window.open('https://yun.ywwl.com/supplyManage/DM27005074D931194412238924920431/_contractManage_list', '_blank')
    }
  });

  return (
    <></>
  )
}
